/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
:host circle.rb_circle {
  height: 100%;
  width: 100%;
  fill: none;
  stroke: #B4BEC5;
  stroke: var(--davinci-color-outline, #B4BEC5);
  stroke-width: calc(1rem/14);
}
:host circle.rb_tick {
  height: 100%;
  width: 100%;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  visibility: hidden;
}
:host svg {
  height: calc(24rem/14);
  width: calc(24rem/14);
  vertical-align: middle;
}
:host .rb_label {
  display: inline-block;
  vertical-align: middle;
  font-size: 1rem;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  padding-left: calc(6rem/14);
  line-height: calc(24rem/14);
}
:host .rb_label slot ::slotted(*) {
  line-height: calc(24rem/14);
  font-size: calc(14rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}

:host([checked]) circle.rb_tick {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  visibility: visible;
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) circle.rb_circle {
  stroke: #D2D9DD;
  stroke: var(--davinci-color-outline-disabled, #D2D9DD);
}
:host([disabled]) circle.rb_tick {
  fill: #D2D9DD;
  fill: var(--davinci-color-outline-disabled, #D2D9DD);
}
:host([disabled]) .rb_label {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) .rb_label slot ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}`;
export { style };
//# sourceMappingURL=RadioButton.style.js.map